<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">business</v-icon> {{ $store.state.user.id_rol !== 2 ? $t('entity.title') : 'Entidad' }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
          v-if="$util.isRol('SUPERADMIN')"
        >
          <template slot="buttons">
            <v-tooltip color="info" top v-if="$store.state.permissions['entidades:create']">
              <v-btn
                @click="sincronizarConPortal()"
                slot="activator"
                color="info">
                <v-icon>sync</v-icon> Sincronizar
              </v-btn>
              <span>Sincronizar con el Portal Único de Trámites</span>
            </v-tooltip>
            <v-tooltip top v-if="$store.state.permissions['entidades:create']">
              <v-btn color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>add</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{$t('entity.add')}}</span>
            </v-tooltip>
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-flex xs9>
                <v-icon>business</v-icon> {{ form.id ? $t('entity.crud.editEnt') :  $t('entity.crud.addEnt') }}
              </v-flex>
              <v-flex xs2 text-md-right>
                <v-chip label color="success" text-color="white" v-if="form.estado == 'ACTIVO'">
                  {{ form.estado }}
                </v-chip>
                <v-chip label color="warning" text-color="white" v-if="form.estado == 'INACTIVO'">
                  {{ form.estado }}
                </v-chip>
              </v-flex>
              <v-flex xs1 text-md-right>
                <v-btn small flat icon @click.native="closeModal()">
                  <v-icon class="red--text">cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation
              >
              <v-card-text class="pt-0">
                <v-container grid-list-md>
                  <h4>{{$t('common.general_information')}}</h4>
                  <v-layout wrap>
                    <v-flex xs12 sm9 md10>
                      <v-combobox
                        id="denominacion"
                        name="nombres"
                        v-model="entidadSelected"
                        :items="entidadList"
                        item-text="denominacion"
                        label="Lista de entidades"
                        v-on:change="getEntidad(entidadSelected)"
                        :disabled="cambiarDatos && form.nombre !== ''"
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs6 sm3 md2>
                      <v-btn
                        v-if="cambiarDatos && !form.id"
                        @click="cambiarEntidad()"><v-icon>compare_arrows</v-icon> Cambiar</v-btn>
                      <!--v-btn
                        color="info"
                        v-if="!cambiarDatos"
                        :loading="loading"
                        :disabled="loading"
                        @click="buscarEntidad()"><v-icon>search</v-icon> Buscar</v-btn-->
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex sm6>
                      <v-text-field
                        name="id_portal"
                        label="Código único de portal"
                        id="id_portal_unico"
                        v-model="form.id_portal_unico"
                        maxlength="20"
                        :disabled="cambiarDatos && form.id_portal_unico !== ''"
                        :rules="$validate(['required'])"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm6>
                      <v-text-field
                        name="sigla"
                        :label="$t('entity.crud.acronym')"
                        id="sigla"
                        v-model="form.sigla"
                        maxlength="20"
                        :disabled="cambiarDatos && form.sigla !== ''"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="nombre"
                        :label="$t('entity.crud.name')"
                        id="nombre"
                        v-model="form.nombre"
                        autofocus
                        maxlength="150"
                        :disabled="cambiarDatos && form.nombre !== ''"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm6>
                      <v-text-field
                        name="codigo_portal"
                        label="Código de entidad"
                        id="codigo_portal"
                        v-model="form.codigo_portal"
                        maxlength="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm6>
                      <v-text-field
                        name="nit"
                        label="NIT"
                        id="nit"
                        v-model="form.nit"
                        maxlength="20"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        name="descripcion"
                        :label="$t('entity.crud.description')"
                        id="descripcion"
                        v-model="form.descripcion"
                        maxlength="500"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-textarea>
                    </v-flex>
                  </v-layout>

                  <h4>{{$t('common.contact_information')}}</h4>
                  <v-layout wrap>
                    <v-text-field
                      name="email"
                      :label="$t('entity.crud.email')"
                      prepend-icon="email"
                      id="email"
                      v-model="form.email"
                      maxlength="100"
                      :rules="$validate(['email'])"
                    ></v-text-field>

                    <v-text-field
                      name="web"
                      :label="$t('entity.crud.web')"
                      prepend-icon="public"
                      id="web"
                      v-model="form.web"
                      maxlength="100"
                      :rules="$validate(['url'])"
                    ></v-text-field>
                  </v-layout>

                  <v-flex xs12>
                    <v-text-field
                      name="direccion"
                      :label="$t('entity.crud.address')"
                      id="direccion"
                      v-model="form.direccion"
                      maxlength="500"
                      :counter="500"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-combobox
                      :label="$t('entity.crud.phones')"
                      chips
                      multiple
                      prepend-icon="phone"
                      v-model="form.telefonos"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          close
                          @input="remove(data.item)"
                          :selected="data.selected"
                        >
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-container>
                <log-datos :data="logDatos" v-if="logDatos"></log-datos>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
                <v-spacer></v-spacer>
                <v-btn flat color="red"
                  @click.native="closeModal()">
                  <v-icon>close</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid">
                  <v-icon>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['entidades:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="openModalEdit(items.item.id, 'entidad', dataGraphql)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!-- <v-tooltip bottom v-if="$store.state.permissions['usuarios:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="generarToken('ENTIDAD', { id_entidad: items.item.id })">
                  <v-icon>vpn_key</v-icon>
                </v-btn>
                <span>Generar token para la entidad</span>
              </v-tooltip> -->
              <!-- <v-tooltip bottom v-if="$store.state.permissions['entidades:delete']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'entidad')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip> -->
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['entidades:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  @change="changeActive(items.item, items.item.id, 'entidad', 'EditEntidad')"
                  hide-details
                  v-if="idEntidad != items.item.id"
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
              <v-icon
                v-if="!$store.state.permissions['entidades:update'] && idEntidad != items.item.id"
                :color="items.item.active === 'ACTIVE' ? 'success' : 'error'">
                {{ items.item.active === 'ACTIVE' ? 'check' : 'close' }}
              </v-icon>
              <v-tooltip bottom>
                <v-btn
                  icon
                  v-if="idEntidad == items.item.id"
                  slot="activator">
                  <v-icon>business</v-icon>
                </v-btn>
                <span>Esta es mi entidad.</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.nombre }}</td>
            <td>{{ items.item.sigla }}</td>
            <td>{{ items.item.web }}</td>
            <td>{{ items.item.direccion }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'INACTIVO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="form"
          lazy-validation
          v-else
          >
          <v-container grid-list-md>
            <h4>{{$t('common.general_information')}}</h4>
            <v-layout wrap>
              <!--
              <v-flex xs3>
                <v-text-field
                  name="id_portal_unico"
                  label="Código único de portal"
                  id="id_portal_unico"
                  v-model="form.id_portal_unico"
                  maxlength="20"
                  :rules="$validate(['required'])"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              -->
              <v-flex sm4>
                <v-text-field
                  name="sigla"
                  :label="$t('entity.crud.acronym')"
                  id="sigla"
                  v-model="form.sigla"
                  maxlength="20"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-text-field
                  name="codigo_portal"
                  label="Código de entidad"
                  id="codigo_portal"
                  v-model="form.codigo_portal"
                  maxlength="20"
                  :rules="$validate(['required'])"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-text-field
                  name="nit"
                  label="NIT"
                  id="nit"
                  v-model="form.nit"
                  maxlength="20"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="nombre"
                  :label="$t('entity.crud.name')"
                  id="nombre"
                  v-model="form.nombre"
                  autofocus
                  maxlength="150"
                  :rules="$validate(['required'])"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="descripcion"
                  :label="$t('entity.crud.description')"
                  id="descripcion"
                  v-model="form.descripcion"
                  maxlength="500"
                  :counter="500"
                  :rules="$validate(['required'])"
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>
            <br>

            <h4>{{$t('common.contact_information')}}</h4>
            <v-layout wrap>
              <v-flex md4>
                <v-text-field
                  name="email"
                  :label="$t('entity.crud.email')"
                  prepend-icon="email"
                  id="email"
                  v-model="form.email"
                  maxlength="100"
                  :rules="$validate(['email'])"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex md4>
                <v-text-field
                  name="web"
                  :label="$t('entity.crud.web')"
                  prepend-icon="public"
                  id="web"
                  v-model="form.web"
                  maxlength="100"
                  :rules="$validate(['url'])"
                ></v-text-field>
              </v-flex>

              <v-flex md4>
                <v-combobox
                  :label="$t('entity.crud.phones')"
                  chips
                  multiple
                  prepend-icon="phone"
                  v-model="form.telefonos"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      close
                      @input="remove(data.item)"
                      :selected="data.selected"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  name="direccion"
                  :label="$t('entity.crud.address')"
                  id="direccion"
                  v-model="form.direccion"
                  maxlength="500"
                  :counter="500"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <h4>{{$t('common.other_information')}}</h4>
            <v-layout wrap>
              <v-flex xs12>
                <v-combobox
                  :label="$t('entity.crud.user_data')"
                  chips
                  multiple
                  v-model="form.datos_usuario"
                >
                  <v-tooltip slot="prepend" top>
                    <v-icon slot="activator" color="#777" dark>notes</v-icon>
                    <span>Especifique qué datos adicionales pueden almacenarse de los usuarios (Ej. Dirección, Estado civil, etc.)</span>
                  </v-tooltip>
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      close
                      @input="removeDatoUsuario(data.item)"
                      :selected="data.selected"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
          <log-datos :data="logDatos" v-if="logDatos"></log-datos>
          <br>
          <v-card-actions>
            <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="$store.state.permissions['tramites:create']">
              <v-btn
                @click="sincronizarTramites()"
                slot="activator"
                color="default">
                <v-icon>sync</v-icon> Sincronizar trámites
              </v-btn>
              <span>Sincronizar trámites con el Portal Único de Trámites</span>
            </v-tooltip>
            <v-btn
              color="primary"
              type="submit"
              :disabled="!valid">
              <v-icon>check</v-icon> Guardar cambios
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';

export default {
  mixins: [ crud, validate, token, logDatos ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
  },
  mounted () {
    if (this.$util.isRol('ADMIN')) {
      this.editItem(this.$store.state.user.id_entidad, 'entidad', this.dataGraphql, false);
    }

    if (this.$util.isRol('SUPERADMIN')) {
      this.loading = true;
      this.$service.get(`system/entidades/portal`)
      .then(response => {
        this.loading = false;
        if (response && response[0]) {
          this.entidadList = response;
        } else {
          this.$refs.form.reset();
        }
      });
    }
  },
  data () {
    return {
      logDatos: null,
      successAlert: false,
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'entidades',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: this.$t('entity.crud.name'), value: 'nombre' },
        { text: this.$t('entity.crud.acronym'), value: 'sigla' },
        { text: this.$t('entity.crud.web'), value: 'web' },
        { text: this.$t('entity.crud.address'), value: 'direccion' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {
        nombre: '',
        sigla: '',
        descripcion: '',
        email: '',
        web: '',
        direccion: '',
        telefonos: [],
        estado: '',
        datos_usuario: ['Otros']
      },
      dataGraphql: `
        id
        nombre
        sigla
        descripcion
        email
        telefonos
        direccion
        codigo_portal
        id_portal_unico
        web
        nit
        estado
        datos_usuario
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [
        {
          field: 'nombre',
          label: this.$t('entity.crud.name'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'sigla',
          label: this.$t('entity.crud.acronym'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('entity.crud.status'),
          type: 'select',
          typeG: 'EstadoEntidad',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'INACTIVO', text: 'INACTIVO' }
          ]
        }
      ],
      entidadSelected: '',
      entidadList: [],
      idEntidad: null,
      valid: true,
      cambiarDatos: false,
      loading: false
    };
  },
  methods: {
    closeModal () {
      this.$store.commit('closeModal');
      this.cambiarDatos = false;
    },
    openModal (data = {}, form = true) {
      this.valid = true;
      this.$refs.form.reset();
      // this.cambiarDatos = false;
      this.logDatos = null;
      if (data.id) {
        if (data.telefonos) {
          data.telefonos = data.telefonos.split(',');
        } else {
          data.telefonos = [];
        }
        this.$nextTick(() => {
          this.logDatos = this.getLogDatos(data);
          this.form = data;
        });
      } else {
        this.form = {
          nombre: '',
          sigla: '',
          descripcion: '',
          email: '',
          web: '',
          direccion: '',
          telefonos: [],
          estado: '',
          datos_usuario: ['Otros']
        };
      }
      if (form) {
        this.$store.commit('openModal');
      }
    },
    openModalEdit (id, mod, data) {
      this.cambiarDatos = true;
      this.editItem(id, mod, data);
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.telefonos && data.telefonos.length > 0) {
          data.telefonos = data.telefonos.join(',');
        } else {
          data.telefonos = null;
        }
        if (!data.datos_usuario) {
          data.datos_usuario = ['Otros'];
        }
        if (data.id) {
          delete data.id;
          delete data.id_portal_unico;
          this.$service.graphql({
            query: `
              mutation edit($id: Int!, $entidad: EditEntidad!) {
                entidadEdit(id: $id, entidad: $entidad) {
                  id
                }
              }
            `,
            variables: {
              id: this.form.id,
              entidad: data
            }
          }).then(response => {
            if (response) {
              this.closeModal();
              this.updateList();
              // this.sincronizarConPortal();
              this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          data.estado = 'ACTIVO';
          this.$service.graphql({
            query: `
              mutation add($entidad: NewEntidad!) {
                entidadAdd(entidad: $entidad) {
                  id
                }
              }
            `,
            variables: {
              entidad: data
            }
          }).then(response => {
            if (response) {
              this.closeModal();
              this.updateList();
              // this.sincronizarConPortal();
              this.entidadList = this.entidadList.filter(item => (item.id_entidad !== data.id_portal_unico));
              this.$message.success();
            }
          });
        }
      }
    },
    remove (item) {
      this.form.telefonos.splice(this.form.telefonos.indexOf(item), 1);
      this.form.telefonos = [...this.form.telefonos];
    },
    removeDatoUsuario (item) {
      this.form.datos_usuario.splice(this.form.datos_usuario.indexOf(item), 1);
      this.form.datos_usuario = [...this.form.datos_usuario];
    },
    sincronizarConPortal () {
      this.$loading.show('Sincronizando entidades');
      this.loading = true;
      let url = `system/entidades/sincronizar`;
      this.$service.get(url)
      .then(response => {
        if (response && response.message) {
          this.$message.success(response.message);
          this.updateList();
        }
        this.loading = false;
      });
    },
    sincronizarTramites () {
      if (this.form.id) {
        this.$loading.show('Sincronizando trámites');
        this.loading = true;
        let url = `system/tramites/sincronizar/${this.form.id}`;
        this.$service.get(url)
        .then(response => {
          if (response && response.message) {
            this.$message.success(response.message);
          }
          this.loading = false;
        });
      }
    },
    getEntidad (value) {
      if (value && value.id_entidad) {
        this.$loading.show('Recuperando datos de entidad');
        this.loading = true;
        let url = `system/entidades/buscar/${value.sigla || '--'}/${value.id_entidad}`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          if (response && response.nombre) {
            this.form = response;
            this.cambiarDatos = true;
          } else {
            this.$refs.form.reset();
          }
        });
      }
    },
    buscarEntidad () {
      // this.form.codigo_portal = this.form.codigo_portal || '0';
      this.form.id_portal_unico = this.form.id_portal_unico || '0';
      if (this.form.sigla && this.form.id_portal_unico) {
        this.$loading.show('Recuperando datos de entidad');
        this.loading = true;
        let url = `system/entidades/buscar/${this.form.sigla}/${this.form.id_portal_unico}`;
        this.$service.get(url)
        .then(response => {
          this.loading = false;
          if (response && response.nombre) {
            this.form = response;
            this.cambiarDatos = true;
          } else {
            this.$refs.form.reset();
            // this.$message.warning(`No se encontró la sigla indicada en el portal único de tramites`, null, { timeout: 12000 });
          }
        });
      } else {
        this.$message.warning(`Debe indicar la sigla y código de portal único de la entidad`, null, { timeout: 12000 });
      }
    },
    // buscarEntidadPorCodigo () {
    //   this.$loading.show('Recuperando datos de entidad');
    //   this.loading = true;
    //   let url = `system/entidades/buscar_codigo/${this.form.codigo_portal}`;
    //   this.$service.get(url)
    //   .then(response => {
    //     this.loading = false;
    //     if (response && response.codigo_portal) {
    //       console.log('-----resp busqueda------------------');
    //       console.log(response);
    //       console.log('------------------------------------');
    //       this.form = response;
    //       this.cambiarDatos = true;
    //     } else {
    //       this.$refs.form.reset();
    //     }
    //   });
    // },
    cambiarEntidad () {
      this.$refs.form.reset();
      this.cambiarDatos = false;
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/entidad/Entidad.vue